import { Button } from "@/components/ui/button";
import { ShoppingCart, Factory, Building2, Shirt, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const SolutionsGrid = () => {
  const solutions = [
    {
      icon: ShoppingCart,
      title: "E-commerce & Retail",
      description: "Multi-channel synchronization for seamless operations",
      link: "/solutions/ecommerce",
      gradient: "from-blue-500/20 to-purple-500/20",
    },
    {
      icon: Factory,
      title: "Manufacturing",
      description: "Production to distribution data management",
      link: "/solutions/manufacturing",
      gradient: "from-orange-500/20 to-red-500/20",
    },
    {
      icon: Building2,
      title: "Wholesale & Distribution",
      description: "B2B catalog and pricing automation",
      link: "/solutions/wholesale",
      gradient: "from-green-500/20 to-emerald-500/20",
    },
    {
      icon: Shirt,
      title: "Fashion & Apparel",
      description: "Complex variant and style management",
      link: "/solutions/fashion",
      gradient: "from-pink-500/20 to-purple-500/20",
    },
  ];

  return (
    <section className="py-8 md:py-12 lg:py-14 px-4" aria-labelledby="solutions-heading">
      <div className="container mx-auto max-w-7xl">
        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 lg:gap-16 items-center mb-8 md:mb-12 lg:mb-16">
          <header className="animate-fade-in">
            <h2 id="solutions-heading" className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6">
              Built for Your Industry
            </h2>
            <p className="text-sm sm:text-base md:text-lg lg:text-xl text-muted-foreground mb-6 md:mb-8">
              Specialized solutions that understand your unique business challenges and deliver measurable results.
            </p>
            <nav className="flex flex-col sm:flex-row gap-3 sm:gap-4" aria-label="Solution actions">
              <Button variant="cta" size="lg" className="w-full sm:w-auto" asChild>
                <Link to="/contact">Get Started</Link>
              </Button>
              <Button variant="outline" size="lg" className="w-full sm:w-auto" asChild>
                <Link to="/features" aria-label="View all platform features">View All Features</Link>
              </Button>
            </nav>
          </header>

          <nav className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 animate-fade-in" aria-label="Industry solutions">
            {solutions.map((solution, index) => (
              <Link
                key={index}
                to={solution.link}
                aria-label={`Learn more about ${solution.title} solutions`}
                className="group relative p-5 sm:p-6 md:p-7 rounded-xl sm:rounded-2xl bg-card hover:shadow-2xl transition-all duration-300 hover-scale overflow-hidden"
              >
                <div className={`absolute inset-0 bg-gradient-to-br ${solution.gradient} opacity-0 group-hover:opacity-100 transition-opacity duration-300`} aria-hidden="true"></div>
                <article className="relative z-10">
                  <div className="w-11 h-11 sm:w-12 sm:h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-3 sm:mb-4 group-hover:scale-110 transition-transform duration-300" aria-hidden="true">
                    <solution.icon className="h-5 w-5 sm:h-6 sm:w-6 text-primary" aria-hidden="true" />
                  </div>
                  <h3 className="text-base sm:text-lg md:text-xl font-bold mb-2">{solution.title}</h3>
                  <p className="text-sm sm:text-sm md:text-base text-muted-foreground mb-3 sm:mb-4 leading-relaxed">
                    {solution.description}
                  </p>
                  <span className="flex items-center text-primary text-sm sm:text-base font-medium group-hover:translate-x-2 transition-transform duration-300">
                    Learn more
                    <ArrowRight className="ml-2 h-3.5 w-3.5 sm:h-4 sm:w-4" aria-hidden="true" />
                  </span>
                </article>
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </section>
  );
};

export default SolutionsGrid;
